<template>
    <div>
        <!-- responsive-header -->
        <responsive-header-component></responsive-header-component>
        <div class="wrapper default shopping-page">
            <header class="main-header default">
                <div class="container">
                    <header-component></header-component>
                </div>
                <navbar-component></navbar-component>
            </header>
            <!-- header-shopping -->
          
            <header class="header-shopping default">
                <div class="container">
                    <div class="row">
                        <div class="col-12 text-center pt-2">
                            <div class="header-shopping-logo default">
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <ul class="checkout-steps">
                                <li>
                                    <a class="active">
                                        <span>انتخاب آدرس</span>
                                    </a>
                                </li>
                                <li class="">
                                    <a>
                                        <span>مشاهده صورت حساب</span>
                                    </a>
                                </li>
                                <li>
                                    <a>
                                        <span>اتمام خرید و ارسال</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
            <!-- header-shopping -->
            <!-- main-shopping -->
            <main class="cart-page default">
                <div class="container" v-if="baseInfo != null">
                    <div class="row">
                        <div class="cart-page-content col-xl-9 col-lg-8 col-md-12 order-1">
                            <div class="cart-page-title">
                                <h1 class="title-address">انتخاب آدرس تحویل سفارش</h1>
                                <a @click="openAddAddressModal" class="btn btn-default add-address-btn">
                                    <label><i style="vertical-align:middle" class="now-ui-icons ui-1_simple-add"></i></label>
                                    افزودن آدرس جدید
                                </a>
                                <div>
                                    <router-link class="btn-redirect-page" to="/">بازگشت به صفحه اصلی</router-link>
                                </div>
                            </div>
                            <section class="page-content default">
                                <div class="address-section">
                                    <div class="checkout-contact">
                                        <div class="checkout-contact-content">
                                            <ul class="checkout-contact-items tahvildarmahal">
                                                <li class="title">تحویل در محل فروشگاه</li>
                                                <li class="title-p">
                                                    {{ baseInfo.Address }}
                                                </li>
                                            </ul>
                                            <div class="checkout-contact-badge">
                                                <label style="margin-bottom:0" class="checkbox-form checkbox-primary">
                                                    <input v-model="isDeliveryAtStore" @change="DeliveryAtStoreSelectedChange()" type="checkbox">
                                                    <span class="checkbox-check"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="address-section-delivery" v-if="!isDeliveryAtStore">
                                    <div class="row">
                                        <ul class="ul-address col-md-12 col-lg-12">
                                            <li v-if="customerAddressess.length <= 0"><div class="emptyaddress">آدرسی برای شما ثبت نشده است.</div></li>
                                            <li>
                                                <div class="title-delivery margin-t">
                                                    <i class="now-ui-icons shopping_delivery-fast"></i>
                                                    <span class="title">انتخاب آدرس جهت ارسال</span>
                                                </div>
                                                <div><hr></div>
                                            </li>
                                            <li v-for="(Info, index) in customerAddressess">
                                                <div class="address-content col-md-12 col-lg-12">
                                                    <div class="address  col-md-8 col-lg-8">
                                                        <div class="radio">
                                                            <input @change="readCarrierInfo(Info.Id)" type="radio" name="addressRadioButton" :id="'radio' + index" :value="Info.Id" v-model="selectedCustomerAddressId">
                                                            <label :for="'radio' + index">
                                                                {{Info.Address}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="address-edit col-md-4 col-lg-4">
                                                        <input @click="findCustomerAddress(Info.Id)" class="btn btn-default" type="button" value="ویرایش و مشاهده" />
                                                    </div>
                                                </div>
                                            </li>
                                            <li>  <div :class="{ loader: !isShowSppineraddress }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:30%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="address-section-carrier" style="margin-top:15px;" v-if="carriers != null && carriers.length > 0">
                                    <div class="row">
                                        <div class="title-delivery margin-t col-12">
                                            <i class="now-ui-icons shopping_delivery-fast"></i>
                                            <span class="title">انتخاب شرکت حامل</span>
                                        </div>
                                        <div class="col-sm-12" style="text-align:center">
                                            <ul>
                                                <li v-for="(carrier, index) in carriers" :class="carrier.IsAvailable == true? '' :  'notIsAvailble'">
                                                    <div class="row">
                                                        <div class="col-lg-3 col-xs-12 border-le">
                                                            <div class="radio">
                                                                <input :disabled="!carrier.IsAvailable" type="radio" name="radio2" :id="'carrier' + index" :value="carrier.Id" v-model="selectedCarrierId">
                                                                <label :for="'carrier' + index">
                                                                    <span class="carrierName"> {{ carrier.Name }} </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div v-if="carrier.IsAvailable == true" class="col-lg-9 col-xs-12 flex">
                                                            <div class="right"><span class="title">هزینه ارسال شما با <span class="tlt-main">{{ carrier.Name }}</span> ، <span class="tlt-main">{{ carrier.DeliveryFee }} ریال</span> می باشد.</span></div>
                                                            <div class="right"><span class="title"> حدود زمان تحویل ،پس از تأیید سفارش حداکثر <span class="tlt-main">{{ carrier.DeliveryDuration }}</span>  می باشد</span></div>
                                                        </div>
                                                        <div v-else class="col-lg-9 col-xs-12 flex">
                                                            <div class="right"><span class="title">ارسال محصولات به این آدرس بوسیله این شرکت امکانپذیر نمی باشد</span></div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                                <div v-if="(selectedCustomerAddressId != null && selectedCarrierId != null)|| isDeliveryAtStore" class="col-md-12 col-xs-12 btn-vetificate">
                                    <div class="vetificate">
                                        <input @click="setAddressToCart" class="btn btn-default confirm-btn" type="button" value="ثبت و گام بعدی" />
                                        <div class="div-loader">
                                            <img class="imgloader" src="/assets/img/loader/loader.svg" />
                                        </div>
                                    </div>
                                </div>
                                <products-compact></products-compact>
                            </section>

                        </div>
                        <aside class="cart-page-aside col-xl-3 col-lg-4 col-md-6 center-section order-2">
                            <div class="checkout-aside">
                                <cart-summary></cart-summary>
                            </div>
                        </aside>
                    </div>
                </div>
                <add-address-modal></add-address-modal>
                <edit-address-modal :addressInfo="addressInfo"></edit-address-modal>
                <city-selector-modal></city-selector-modal>
            </main>
            <!-- main-shopping -->
            <!-- footer -->
            <footer-component></footer-component>
            <!-- footer -->
        </div>
    </div>
</template>

<script>
    import cartSummary from "../cartComponents/cartSummary.vue"
    import { httpPromise } from "../../module/httpUtility";
    import addAddressModal from "../profileComponent/address/addAddressModal.vue";
    import editAddressModal from "../profileComponent/address/editAddressModal.vue";
    import citySelectorModal from "../profileComponent/address/citySelectorModal.vue";
    import { addressChangedEventBus } from "../../eventBus/eventBus";
    import productsCompact from "../cartComponents/productsCompact.vue";
    import cityDelivery from "../addressComponents/cityDeliveryModal.vue";
    import { getCart } from "../../module/cart";

    export default {
        data() {
            return {
                customerAddressess: [],
                addressInfo: {},
                carriers: [],
                isDeliveryAtStore: false,
                selectedCustomerAddressId: null,
                selectedCarrierId: null,
                isShowSppineraddress: false,
            }
        },
        components: {
            'cart-summary': cartSummary,
            'city-selector-modal': citySelectorModal,
            'add-address-modal': addAddressModal,
            'edit-address-modal': editAddressModal,
            'products-compact': productsCompact,
            'city-delivery': cityDelivery,
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
        },
        methods: {
            DeliveryAtStoreSelectedChange() {
                this.selectedCustomerAddressId = null;
                this.selectedCarrierId = null,
                    this.carriers = [];
            },
            openAddAddressModal() {
                $(function () {
                    $('#addAddressModal').modal({ backdrop: 'static', keyboard: false });
                    $('#addAddressModal').modal('show');
                });
            },
            findCustomerAddress(addressId) {
                httpPromise(this, '/v1/Identity/CustomersAddress/Find', 'get', { AddressId: addressId },
                    response => {
                        this.addressInfo = response.data.Value;
                        $(function () {
                            $('#editAddressModal').modal({ backdrop: 'static', keyboard: false });
                            $('#editAddressModal').modal('show');
                        });
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                    });
            },
            readCustomerAddresses() {
                this.isShowSppineraddress = true;
                httpPromise(this, '/v1/Identity/CustomersAddress/Read', 'get', '',
                    response => {
                        this.customerAddressess = response.data.Value;
                        if (this.cart.CartInfo.IsPickup == true)
                            this.isDeliveryAtStore = true;
                        else {
                            this.selectedCustomerAddressId = this.cart.CartInfo.CustomerAddressId;
                            if (this.selectedCustomerAddressId != null)
                                this.readCarrierInfo(this.selectedCustomerAddressId);
                        }
                        this.isShowSppineraddress = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppineraddress = false;
                    });
            },
            readCarrierInfo(customerAddressId) {
                this.carriers = [];
                this.selectedCarrierId = null;
                httpPromise(this, '/v1/BasicDefinitions/Carriers/Read', 'get', { CustomerAddressId: customerAddressId, HashCartId: localStorage.getItem('CartHashId') },
                    response => {
                        this.carriers = response.data.Value;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                    });
            },

            setAddressToCart() {
                if (this.isDeliveryAtStore) {
                    this.selectedCustomerAddressId = -1;
                    this.selectedCarrierId = 0;
                }
                httpPromise(this, '/v1/Orders/CartAddress/Apply', 'post', { CarrierId: this.selectedCarrierId, CustomerAddressId: this.selectedCustomerAddressId, HashCartId: localStorage.getItem('CartHashId') },
                    response => {
                        toastr.remove();
                        toastr.success(response.data.Message);
                        getCart(this, '');
                        //if (this.cart.CartInfo.CustomerGroupId != 2)
                        //    setTimeout(() => this.$router.push('/invoice'), 1000);
                        //else
                            setTimeout(() => this.$router.push('/colleagueOrders'), 1000);
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                    });

            },
            scrollTop() {
                $(function () {
                    $('html, body').scrollTop(0);
                });
            }
        },
        beforeMount() {
            createPageTitle('انتخاب آدرس');
            if (this.cart == null || (this.baseInfo == null && this.baseInfo.MinimumOrders != 0 && this.cart.CartInfo.SubTotalAmount < this.baseInfo.MinimumOrders))
                this.$router.push('/cart');
            else
                this.readCustomerAddresses();
        },
        created: function () {
            addressChangedEventBus.$on('customerAddressesUpdated', () => {
                this.readCustomerAddresses();
            });
            this.scrollTop();
        },
        beforeDestroy() {
            addressChangedEventBus.$off('customerAddressesUpdated');
        },
    }
</script>

<style scoped>
    .tlt-main {
        font-size: 15px;
        font-weight: 600;
    }

    .title {
        font-weight: 500;
    }

    .flex {
        align-items: inherit;
        flex-direction: column;
    }

    .right {
        text-align: right;
    }

    .address-section-carrier ul li.notIsAvailble .title {
        color: #ccc;
    }

    .address-section-carrier ul li .border-le .radio {
        margin-bottom: 0;
        padding: 20px;
    }

    .address-section-carrier ul li .border-le {
        border-left: 1px solid #ddd;
    }

    .address-section-carrier ul {
        border: 1px solid #ddd;
        margin: 20px;
    }

        .address-section-carrier ul li {
            border: 1px solid #ddd;
        }

    .inline {
        display: inline-block;
    }

    .address-section-carrier .radio label {
        padding-right: 22px;
        padding-left: 0;
    }

    .address-section-carrier {
        background-color: #fff;
        padding: 10px 0px 10px 0px;
        overflow: hidden;
    }

    .content-img-radio img {
        width: 100px;
        height: 100px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
        margin-bottom: 8px;
        padding: 5px;
    }

    .title-delivery {
        margin-right: 25px;
    }

    .margin-t {
        margin-top: 20px;
    }

    .title-delivery .title {
        font-size: 16px;
        font-weight: bold;
        color: #6d6d6d;
    }

    .title-delivery i {
        vertical-align: middle;
        padding-left: 3px;
        font-size: 17px;
        color: #a5a5ad;
    }

    .confirm-btn {
        background-color: #addd82;
        transition: all .3s;
    }

        .confirm-btn:hover {
            background-color: #9fce75;
            transition: all .3s;
        }

    .ul-address {
        margin-bottom: 0;
    }

    .emptyaddress {
        text-align: center;
        padding: 25px;
        background-color: #ebf1f7;
        margin: 10px;
        border-radius: 5px;
    }

    .content-loader {
        position: relative;
    }

    .vetificate .div-loader {
        position: absolute;
        display: none;
    }

    .content-loader .div-loader {
        position: absolute;
        background-color: #eedfdf;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
    }

        .content-loader .div-loader img {
            width: 45px;
        }

    .shopping-page header.header-shopping .checkout-steps li a {
        display: inline-block;
        height: 39px;
    }

    .cart-page-title {
        position: relative;
    }

        .cart-page-title .btn-redirect-page {
            position: absolute;
            top: -15px;
            left: -320px;
            border-bottom: 1px dashed #1ca2bd;
            margin-top: 10px;
            display: inline-block;
            border-radius: 5px;
            color: #1ca2bd;
            transition: all .3s;
            padding: 6px;
            font-size: 12px;
            z-index: 1;
        }

    .shopping-page header.header-shopping .checkout-steps li.active::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 6px;
        background-color: #00bfd6;
        right: -50%;
        bottom: -20px;
        z-index: 1000000;
    }

    .btn-redirect-page:hover {
        transition: all .3s;
        color: #1ca2bd;
    }

    .cart-page-title {
        margin: 7px 0 11px;
    }

    .cart-page .checkout-aside {
        margin-top: 80px;
    }

    .shopping-page .checkout-contact-badge {
        width: 41px;
        height: 41px;
        background-color: #f3feff;
        -webkit-box-shadow: 0 8px 9px 0 rgba(0, 0, 0, .05);
        box-shadow: 0 8px 9px 0 rgba(0, 0, 0, .05);
        border: 1px solid #8dd4dd;
        position: absolute;
        right: -17px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        border-radius: 50%;
        text-align: center;
        line-height: 41px;
        color: #2fc9dc;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .shopping-page .checkout-contact-location {
        background-color: #888;
        color: #fff;
    }

    .cart-page-content .cart-page-title .title-address {
        display: inline-block;
    }

    .cart-page-content .cart-page-title .add-address-btn {
        float: left;
        font-size: 16px;
        padding: 6px;
        border: 1px solid #12b65c;
        color: #12b65c;
        background-color: #fff;
        border-radius: 5px;
        padding-top: 9px;
    }

    .btn-vetificate {
        background-color: #fff;
        margin-top: 20px;
        padding: 7px;
    }

        .btn-vetificate .vetificate .btn {
            width: 100%;
            font-size: 15px;
        }

    .address-section-delivery {
        background-color: #fff;
        padding: 10px 0px 10px 0px;
        overflow: hidden;
    }

        .address-section-delivery li {
            display: block;
        }

        .address-section-delivery .address-content .address {
            display: inline-block;
            text-align: right;
        }

        .address-section-delivery .address-content .address-edit {
            display: inline-block;
            text-align: left;
        }

            .address-section-delivery .address-content .address-edit .btn {
                background-color: #fff !important;
                color: #ddb0b0;
                border: 1px solid #666;
                padding: 5px;
                margin-right: 25px;
            }

    .out-of-range {
        background-color: #e38686;
        border-radius: 7px;
        padding-left: 3px;
        padding-right: 3px;
        color: #fff;
    }

    .address-section-delivery .address-content .address-edit .btn:hover {
        color: #555;
    }

    @media only screen and (min-width: 0px) and (max-width: 1077px) {
        .header-shopping {
            margin-top: 100px;
        }
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .address-section-carrier ul li .border-le {
            border-left: unset;
        }

        .shopping-page header.header-shopping .checkout-steps li a.active::after {
            bottom: -23px;
        }

        .title-address {
            margin-bottom: 0;
        }

        .address-section-delivery .address-content .address {
            font-size: 12px;
        }

        .cart-page-title {
            margin: 38px 0 20px;
            padding: 0 10px;
            position: relative;
        }

            .cart-page-title h1 {
                color: inherit;
                font-size: 14px;
                line-height: 31px;
                font-weight: 700;
            }

        .cart-page-content .cart-page-title .add-address-btn {
            float: left;
            font-size: 12px;
            padding: 6px;
            padding-top: 6px;
            border: 1px solid #12b65c;
            color: #12b65c;
            background-color: #fff;
            border-radius: 5px;
            padding-top: 9px;
        }

        .cart-page-title .btn-redirect-page {
            position: absolute;
            top: -45px;
            left: 0;
            border-bottom: 1px dashed #1ca2bd;
            margin-top: 12px;
            display: inline-block;
            border-radius: 5px;
            color: #1ca2bd;
            -webkit-transition: all .3s;
            transition: all .3s;
            padding: 4px;
            font-size: 12px;
            z-index: 1;
        }
    }
</style>